import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import initializers from '../../dependencies/initializers.js'



import imgHero from '../../images/hero_img_mapping.png'
import imgSectionOne from '../../images/img_mapping_01.png'
import imgSectionTwo from '../../images/img_mapping_02.png'
import imgRoundedRightTop from '../../images/rounded_top_right.png'

import { accesslog, translate } from '../../helpers/global.js'

import { usersGetDetailAsync } from '../../actions/users.js'
import { fetchWeeklyDemoData } from '../../helpers/fetchWeeklyDemoData.js'

class TalentMapping extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			weeklyDemoData: {
				webinar_link: ""
			},
			isLoadingWeeklyDemo: false
		};
	}

	async componentDidMount() {
		window.scrollTo(0, 0)
		this.setState({ isLoadingWeeklyDemo: true });
		const weeklyDemoData = await fetchWeeklyDemoData();
		this.setState({ weeklyDemoData, isLoadingWeeklyDemo: false });
	}

  chooseOpt(val) {
		const url_api = initializers.api_host
		  if(val === '1') {
			  if (process.env.NODE_ENV === 'development') {
				window.location = 'http://localhost:3000/'
			} else if (url_api == 'https://beta.astrnt.co') {
	
				window.location = 'https://test.astrnt.co/'
	
			} else {
				window.location = 'https://astrnt.co/'
			}
		  } else {
			  if (process.env.NODE_ENV === 'development') {
				window.location = 'http://localhost:3000/'
			} else if (url_api == 'https://beta.astrnt.co') {
	
				window.location = 'https://test.astrnt.id/'
	
			} else {
				window.location = 'https://astrnt.id/'
			}
		  }
		}

  render() {
    const {
      globalGetLanguages,
      user
    } = this.props
    const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
    const { weeklyDemoData, isLoadingWeeklyDemo } = this.state;
    return (
			<div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />
        <div className="banner ai">
          <section>
            <div className="ban-text apis">
              <div className="title-1">Mapping Talent with</div>
              <div className="title-1">Clarity and Purpose</div>              

              <p className='sub-title-1' style={{ marginTop: '20px' }}>
                Know Who’s Ready for What
              </p>

              <div className='content-desc-technical'>
                As companies grow, understanding your own people becomes harder. Roles change, teams evolve, 
                and potential can get lost in the day-to-day. Talent mapping helps organisations see the big picture—so development, 
                rotation, and succession decisions are grounded in real insight.
              </div>

              <div className={`ban-link`}>
                <Link onClick={() => {
                  document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                  accesslog('talent-management/internal-mapping', 'button_talk_to_an_expert');
                }} className="try">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
                <a href={weeklyDemoData.webinar_link} target="_blank" className={`request-demo-logged${weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                  onClick={() => accesslog('talent-management/internal-mapping', 'button_register_for_demo')}
                >Register for Demo</a>
              </div>
              <div className={`ban-link hide`}>
                <Link onClick={() => document.getElementById('modal_talk_expert').classList.add('show-cta-modal')} className='try'>{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
              </div>
              <a href="#" className="vid-msg">
                <img src={imgHero} />
              </a>
            </div>
          </section>
        </div>


     <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <a href="#" className="vid-msg-right-top">
            <img src={imgRoundedRightTop} />
          </a>

          <section className='flex-container position-relative'>
            <div className='flex-item-left'>
              <div className='vertical-item--center' style={{ margin: '0 70px 0 0' }}>
                <img className='img-100' src={imgSectionOne}  />
              </div>
            </div>
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc-point'>
                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                  Why Talent Mapping Often Gets <br />Overlooked
                  </h2>
                  <p className='m-b-24'>
                    Many organisations want to grow from within but struggle to see who’s ready. Without clear structure, mapping talent turns into guesswork.
                  </p>
                  <p className='m-b-8'>Common challenges:</p>  
                  <ul>
                    <li><i className="fas fa-check" />Promotions are based on familiarity, not potential</li>
                    <li><i className="fas fa-check" />Teams work in silos with no shared visibility</li>
                    <li><i className="fas fa-check" />HR lacks a way to compare people across units or levels</li>
                    <li><i className="fas fa-check" />There’s no consistent data behind movement or succession</li>
                  </ul>

                </div>
              </div>
            </div> 
          </section>
      </div>
    
    <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>

                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                    What Talent Mapping Actually <br />Looks Like

                  </h2>
                  <p className='m-b-24'>At its core, talent mapping is about visibility.<br />
                    It’s about knowing who you have, where they are now,<br />
                     and where they could go next—with context, not <br />assumption.</p>
                  <p className='m-b-8'>Mapping typically considers:</p>  
                  <ul>
                    <li><i className="fas fa-check" />Readiness for new roles or challenges</li>
                    <li><i className="fas fa-check" />How someone thinks, leads, and collaborates</li>
                    <li><i className="fas fa-check" />Where people fit beyond their current title</li>
                    <li><i className="fas fa-check" />Cultural alignment and growth potential</li>
                    <li><i className="fas fa-check" />Who might need support, not just recognition</li>
                  </ul>
                </div>
              </div>
            </div> 
            <div className='flex-item-left'>
              <div className='vertical-item--center' style={{ margin: '0 70px 0 0' }}>
                <img className='img-100' src={imgSectionTwo} />
              </div>
            </div>

          </section>
      </div>
      <div className="section-gray single-triangle triangle-right" style={{position: 'relative'}}>
          <section className='p-t-50 p-b-50'>
            <div className='ai-interview-start'>
              <h1>Give Your People and Plans <br />a Clearer Direction</h1>
              <h4>With the right visibility, talent decisions feel less reactive and more intentional. <br />
              Talent mapping gives HR, managers, and leadership a clearer path forward—for <br />
              the business and for every person in it.</h4>
                <div className="ban-text-start-demo">
                <div className={`ban-link`}>
                  <Link onClick={() => {
                    document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                    accesslog('talent-management/internal-mapping', 'button_talk_to_an_expert');
                  }} className="try">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
                  <a href={weeklyDemoData.webinar_link} target="_blank" className={`request-demo-logged${weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                    onClick={() => accesslog('talent-management/internal-mapping', 'button_register_for_demo')}
                  >Register for Demo</a>
                </div>
              </div>

            </div>
          </section>
      </div>

        
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
    globalGetLanguages:state.globalGetLanguages,
    user: state.user
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TalentMapping)
